<template>
  <div class="dashboard">
    <LmsDashboard v-if="gconf.ui.home_setting == 'LMS'"/>
    <Dashboardv2 v-else-if="gconf.ui.home_setting == 'Dashboard' && permissions.includes('READ_V2_DASHBOARD')"/>
    <Dashboard v-else-if="gconf.ui.home_setting == 'Dashboard' && permissions.includes('READ_V1_DASHBOARD')"/>
    <div class="inner-wrap">

    </div>
  </div>
</template>

<script>
import Dashboard from "@/components/modules/dashboard/Dashboard";
import Dashboardv2 from "@/components/modules/dashboard/Dashboardv2";
import LmsDashboard from "@/views/custom/LMSDashboard";
import { mapState } from 'vuex';

export default {
  name: 'Home',
  components: {
    Dashboard,
    LmsDashboard,
    Dashboardv2
  },
  beforeMount() {
    this.gconf = window.gconf;
    if(this.gconf.ui.home_setting == "CpList") {
      this.$router.push("/cps");
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.user.user_info.permissions
    })
  },
  data() {
    return {
      gconf: {}
    }
  }
}
</script>

<style lang="scss">
.dashboard{
  // background: #eff3fa;
  & > .inner-wrap{
    & > .block {
      // flex: auto;
      height: 270px;
      min-width: 150px;
    }
  }
}
</style>